import React from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { PlusOutlined } from "@ant-design/icons";
import { Player } from "video-react";
import videoPoster from "../../Imgs/HomePage/videoPoster.jpg";

// CSS Files
import "../../../../node_modules/video-react/dist/video-react.css";
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/Introduction.css";

import sandoghKeshavarzi from "../../Imgs/HomePage/Sandogh/2.png";
import parvane from "../../Imgs/HomePage/Sandogh/parvane.jpg";

const SandoghKeshavarzi = (props) => {
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <Row>
        <Col span={3}></Col>
        <Col span={8}>
          <Margin top={5}></Margin>
          <div className="videoDashBorder" style={{marginTop:"100px"}}>
            <img className="videoStyle" src={parvane} />
          </div>
          <Margin bottom={5}></Margin>
        </Col>
        <Col span={1}></Col>
        <Col span={9}>
          <Margin top={5}></Margin>
          <h5
            style={{
              fontFamily: "IRANSans",
              color: "#ed1c24",
              marginTop: "-10px",
              textAlign: "right",
            }}
          >
            <strong>صندوق بیمه کشاورزی</strong>
          </h5>
          <Margin top={3}></Margin>
          <p className="textParagraph">
            شرکت ایرانیان پوشش در کنار رشته های بیمه بازرگانی در سال 1394 با اخذ
            مجوز از نهاد ناظر وارد فرآیند ارزیابی خسارت محصولات کشاورزی و
            دام و طیور گردید که در این روند با اغلب شرکت های بیمه گر همکاری های
            گسترده ای داشته است. این مجموعه در نهایت موفق گردید با کسب موافقت
            هیات مدیره صندوق بیمه کشاورزی، اولین نمایندگی حقوقی ارزیابی خسارت و
            ریسک در بیمه های کشاورزی را در این حوزه با شماره پروانه فعالیت "یک"
            از صندوق بیمه کشاورزی هم اخذ نماید و بعنوان اولین شرکتی ارزیاب خسارت
            حقوقی توانسته است ارزیاب مورد وثوق بالاترین نهاد حمایتی در حوزه
            کشاورزی لقب بگیرد. ایرانیان پوشش مفتخر است که در حال حاضر در سراسر
            کشور بالغ بر ۷۴ درصد پرتفو خسارت کشاورزی به خود اختصاص داده است حتی
            در 16 استان بزرگ صدرصد فرایند ارزیابی به ایرانیان پوشش واگذار گردیده
            است .این استانها شامل تهران، اصفهان، فارس، خراسان رضوی، کرمان ،
            یزد،آذربایجان غربی، کردستان، کرمانشاه، همدان، مازندران، خراسان
            شمالی، کرمان، منطقه جنوب، سیستان و بلوچستان، هرمزگان و استان مرکزی
            می باشند که در این استانهای بزرگ با در اختیار داشتن کل پرتفو با
            استفاده از کارشناسان ارزیاب، خسارت کشاورزان را ارزیابی خسارت و حتی
            زمان صدور بیمه نامه ارزیابی ریسک ( پايش فنولوژي ) می نماید.
          </p>
          <Margin bottom={3}></Margin>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Margin top={4}>
            <p
              style={{
                fontFamily: "IRANSans",
                color: "#ed1c24",
                direction: "rtl",
                textAlign: "right",
                fontSize: "1.05em",
              }}
            >
              <strong>صندوق بیمه کشاورزی</strong>
            </p>
          </Margin>
        </Col>
        <Col span={1}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <p className="textParagraphTablet">
            شرکت ایرانیان پوشش در کنار رشته های بیمه بازرگانی در سال 1394 با اخذ
            مجوز از نهاد ناظر وارد فرآیند ارزیابی خسارت محصولات کشاورزی و
            دام و طیور گردید که در این روند با اغلب شرکت های بیمه گر همکاری های
            گسترده ای داشته است. این مجموعه در نهایت موفق گردید با کسب موافقت
            هیات مدیره صندوق بیمه کشاورزی، اولین نمایندگی حقوقی ارزیابی خسارت و
            ریسک در بیمه های کشاورزی را در این حوزه با شماره پروانه فعالیت "یک"
            از صندوق بیمه کشاورزی هم اخذ نماید و بعنوان اولین شرکتی ارزیاب خسارت
            حقوقی توانسته است ارزیاب مورد وثوق بالاترین نهاد حمایتی در حوزه
            کشاورزی لقب بگیرد. ایرانیان پوشش مفتخر است که در حال حاضر در سراسر
            کشور بالغ بر ۷۴ درصد پرتفو خسارت کشاورزی به خود اختصاص داده است حتی
            در 16 استان بزرگ صدرصد فرایند ارزیابی به ایرانیان پوشش واگذار گردیده
            است .این استانها شامل تهران، اصفهان، فارس، خراسان رضوی، کرمان ،
            یزد،آذربایجان غربی، کردستان، کرمانشاه، همدان، مازندران، خراسان
            شمالی، کرمان، منطقه جنوب، سیستان و بلوچستان، هرمزگان و استان مرکزی
            می باشند که در این استانهای بزرگ با در اختیار داشتن کل پرتفو با
            استفاده از کارشناسان ارزیاب، خسارت کشاورزان را ارزیابی خسارت و حتی
            زمان صدور بیمه نامه ارزیابی ریسک ( پايش فنولوژي ) می نماید.
          </p>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
          <div className="videoDashBorder">
            <img className="videoStyle" src={parvane} />
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  ) : (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Margin top={4}></Margin>

          <p
            style={{
              fontFamily: "IRANSans",
              color: "#ed1c24",
              direction: "rtl",
              textAlign: "right",
              fontSize: ".95em",
              marginTop: "-10px",
            }}
          >
            <strong>صندوق بیمه کشاورزی</strong>
          </p>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <p className="textParagraphMobile">
            شرکت ایرانیان پوشش در کنار رشته های بیمه بازرگانی در سال 1394 با اخذ
            مجوز از نهاد ناظر وارد فرآیند ارزیابی خسارت محصولات کشاورزی و
            دام و طیور گردید که در این روند با اغلب شرکت های بیمه گر همکاری های
            گسترده ای داشته است. این مجموعه در نهایت موفق گردید با کسب موافقت
            هیات مدیره صندوق بیمه کشاورزی، اولین نمایندگی حقوقی ارزیابی خسارت و
            ریسک در بیمه های کشاورزی را در این حوزه با شماره پروانه فعالیت "یک"
            از صندوق بیمه کشاورزی هم اخذ نماید و بعنوان اولین شرکتی ارزیاب خسارت
            حقوقی توانسته است ارزیاب مورد وثوق بالاترین نهاد حمایتی در حوزه
            کشاورزی لقب بگیرد. ایرانیان پوشش مفتخر است که در حال حاضر در سراسر
            کشور بالغ بر ۷۴ درصد پرتفو خسارت کشاورزی به خود اختصاص داده است حتی
            در 16 استان بزرگ صدرصد فرایند ارزیابی به ایرانیان پوشش واگذار گردیده
            است .این استانها شامل تهران، اصفهان، فارس، خراسان رضوی، کرمان ،
            یزد،آذربایجان غربی، کردستان، کرمانشاه، همدان، مازندران، خراسان
            شمالی، کرمان، منطقه جنوب، سیستان و بلوچستان، هرمزگان و استان مرکزی
            می باشند که در این استانهای بزرگ با در اختیار داشتن کل پرتفو با
            استفاده از کارشناسان ارزیاب، خسارت کشاورزان را ارزیابی خسارت و حتی
            زمان صدور بیمه نامه ارزیابی ریسک ( پايش فنولوژي ) می نماید.
          </p>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Margin top={3}></Margin>

          <div className="videoDashBorder">
            <img className="videoStyle" src={parvane} />
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  );
};

export default SandoghKeshavarzi;
